import { Popup } from '@vis.gl/react-maplibre';
import { useLandmarkStore } from '../state/landmarks';

/**
 * Compact MapLibre popup for baseline-tier landmarks.
 *
 * Renders only when a baseline landmark is selected — rich content (Wikipedia
 * summary, photo carousel, scholarly citations) lives in `LandmarkSidePanel`
 * for the featured tier.
 */
export function BaselinePopup() {
  const selectedLandmark = useLandmarkStore((state) => state.selectedLandmark);
  const selectLandmark = useLandmarkStore((state) => state.selectLandmark);

  if (!selectedLandmark || selectedLandmark.tier !== 'baseline') return null;

  const heritageRecordUrl = `https://inventaris.onroerenderfgoed.be/erfgoedobjecten/${selectedLandmark.oerId}`;

  return (
    <Popup
      longitude={selectedLandmark.coordinates[0]}
      latitude={selectedLandmark.coordinates[1]}
      onClose={() => selectLandmark(null)}
      closeButton
      closeOnClick={false}
      anchor="bottom"
      offset={12}
      maxWidth="280px"
      className="map-lens-baseline-popup"
    >
      <div data-testid="baseline-popup" style={{ fontSize: '0.875rem', lineHeight: 1.4 }}>
        <strong style={{ display: 'block', fontFamily: 'var(--font-serif)', fontSize: '1rem' }}>
          {selectedLandmark.name}
        </strong>
        {selectedLandmark.alternativeNames && selectedLandmark.alternativeNames.length > 0 ? (
          <span
            style={{
              display: 'block',
              color: 'var(--text-muted)',
              fontStyle: 'italic',
              fontSize: '0.8rem',
              marginTop: 2,
            }}
          >
            {selectedLandmark.alternativeNames.join(' · ')}
          </span>
        ) : null}
        {selectedLandmark.period ? (
          <span style={{ display: 'block', color: 'var(--text-muted)', marginTop: 4 }}>
            {selectedLandmark.period}
          </span>
        ) : null}
        {selectedLandmark.type ? (
          <span style={{ display: 'block', color: 'var(--text-muted)', marginTop: 4, fontSize: '0.8rem' }}>
            {selectedLandmark.type}
          </span>
        ) : null}
        <a
          href={heritageRecordUrl}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="baseline-heritage-link"
          style={{ display: 'inline-block', marginTop: 'var(--space-2)' }}
        >
          View heritage record →
        </a>
      </div>
    </Popup>
  );
}
